import randomItem from 'random-item';
import randomInt from 'random-int';

function pickRandomFromRanges(ranges) {
  const [min, max] = randomItem(ranges);
  return randomInt(min, max);
}

export default function calculateNewPosition({
  windowWidth,
  windowHeight,
  objectWidth,
  objectHeight,
  mouseX,
  mouseY,
}) {
  const horizontalLowerRange = [0, mouseX - objectWidth];
  const horizontalUpperRange = [mouseX, windowWidth - objectWidth];

  const verticalLowerRange = [0, mouseY - objectHeight];
  const verticalUpperRange = [mouseY, windowHeight - objectHeight];

  return {
    x: pickRandomFromRanges([horizontalLowerRange, horizontalUpperRange]),
    y: pickRandomFromRanges([verticalLowerRange, verticalUpperRange]),
  };
}



// WEBPACK FOOTER //
// ./src/calculateNewPosition.js